module.exports = __webpack_public_path__ + "img/grandparent-love-handsign.94f8f0c9.png";